import customerModal from "./customer.modal";
import { firstUpperCase } from "./common.js";
export const getCommonField = fields => {
  let phone = fields[customerModal.PHONE];
  let first_name = firstUpperCase(fields[customerModal.FIRST_NAME]);
  let last_name = firstUpperCase(fields[customerModal.LAST_NAME]);
  let name = `${first_name} ${last_name}`;
  return { phone, first_name, last_name, name };
};

export const getOptionValue = (vm, form) => {
  let global = vm.$store.getters.globalFields;
  let service = vm.$store.getters.serviceFields;
  let makes = vm.$store.getters.makes;
  let makesUnlocking = vm.$store.getters.makesUnlocking;
  let zips = vm.$store.getters.zipcodes;
  let fields = global.concat(service);
  let doc = {};
  Object.keys(form).forEach(key => {
    let val = form[key];
    let item = fields.find(item => {
      return item.id == key;
    });
    if (item != null) {
      let { field_type, options } = item;
      if (field_type == "select") {
        let opt = options.find(item => {
          return item.name == val;
        });
        if (opt) doc[key] = opt.value;
      }
    }
    if (key == customerModal.MAKE) {
      let item = makes.find(item => {
        return item.id == val;
      });
      if (item != null) doc[key] = item.name;
    }
    if (key == customerModal.MAKE_UNLOCKING) {
      let item = makesUnlocking.find(item => {
        return item.id == val;
      });
      if (item != null) doc[key] = item.name;
    }
    if (key == customerModal.ZIPCODE) {
      let item = zips.find(item => {
        return item.id == val;
      });
      if (item != null) doc[key] = item.price;
    }
  });
  return doc;
};
export const formatFormula = ({ formula }, fields, options) => {
  let message = formula;
  let $ = window.$;
  let doc = document.createElement("div");
  doc.innerHTML = message;
  $(doc)
    .find("label")
    .each((i, item) => {
      let id = $(item).attr("data-id");
      let val = fields[id];
      val = parseFloat(val);
      if (options[id] != undefined) val = options[id];
      if (isNaN(val)) val = 0;
      $(item).html(val);
    });
  message = doc.innerText;
  message = message.split("\n").join("<br/>");
  message = message.split("x").join("*");
  return message;
};
export const getHowPaidCharge = (doc, val, vm) => {
  let percentage = 0;
  let how = doc[customerModal.HOW_PAID];
  let how_paid = vm.$store.getters.globalFields.find(item => {
    return item.id == customerModal.HOW_PAID;
  });
  if (how_paid instanceof Object && how_paid.options instanceof Object) {
    let how_paid_value = how_paid.options.find(item => {
      return item.name == how;
    });
    percentage = 0;
    if (how_paid_value != null) {
      percentage = Number(how_paid_value.value);
    }
    if (isNaN(percentage) || !percentage) percentage = 0;
    percentage = percentage / 100;
    percentage = Number(val) * percentage;
  }
  return Number(percentage);
};

export const getCreditCardCharges = (form, vm) => {
  let cal = 0;
  let options = getOptionValue(vm, form);
  let item = vm.$store.getters.globalFields.find(item => {
    return item.id == customerModal.TOTAL;
  });
  let formula = formatFormula(item, form, options);
  var FormulaParser = require("hot-formula-parser").Parser;
  var parser = new FormulaParser();
  let val = parser.parse(formula);
  if (val.error == null) {
    cal = val.result;
  }
  cal = getHowPaidCharge(form, cal, vm);
  return cal.toFixed(2);
};
